// ============================================================================
// ITALIAN TRANSLATIONS - CHAPTER 8: IL SOCCORSO DELL'ALTISSIMO (BONUS)
// ============================================================================
// Livello 92 (1 livello bonus, 3 domande)

export const chapter8Translations = {
  name: "Il Soccorso dell'Altissimo",
  description: "Chi dimora al riparo dell'Altissimo riposa all'ombra dell'Onnipotente",
  
  spiritualWisdom: {
    principle: "Sei arrivato in cima alla montagna, e la conoscenza è stata acquisita",
    scripture: "Chi dimora al riparo dell'Altissimo riposa all'ombra dell'Onnipotente (Salmo 91:1)",
    application: "La fede incrollabile richiede esperienza di vita, misericordia e il vero amore di Gesù. Le prove metteranno alla prova il tuo cuore, il vero cammino scelto."
  },
  
  levels: {
    92: {
      name: "Il Riparo dell'Altissimo",
      challenge: "Sei in cima alla montagna... Ma la fede incrollabile inizia ora...",
      easy: {
        question: "Chi è Gesù per te personalmente?",
        options: [
          "Un semplice profeta",
          "Il mio Signore e Salvatore personale",
          "Una leggenda",
          "Un filosofo"
        ],
        hint: "È colui che dà la sua vita per salvarci",
        funFact: "✝️ Gesù è Dio! Non è solo un personaggio storico - È vivo e desidera una relazione personale con ognuno di noi!"
      },
      medium: {
        question: "Perché digiunare come Daniele ci permette di ascoltare meglio Dio?",
        options: [
          "Per perdere peso",
          "Per privarci di ciò che amiamo e avere un cuore trasformato",
          "Per impressionare gli altri",
          "Per essere più forte"
        ],
        hint: "Privati di ciò che ami di più, nella calma e nella saggezza",
        funFact: "🙏 Il digiuno spirituale prepara il nostro cuore a trasformazioni profonde - spesso dolorose - che ci avvicinano a Dio!"
      },
      hard: {
        question: "Qual è la vera risposta del cuore di fronte a tutta questa conoscenza acquisita?",
        options: [
          "Ora sono perfetto",
          "Ti do il mio cuore Gesù e desidero essere battezzato",
          "So meglio degli altri",
          "Non ho più bisogno di aiuto"
        ],
        hint: "La vera fede porta all'abbandono totale e all'impegno con Gesù",
        funFact: "🌟✨ Sei arrivato in cima alla montagna, e la conoscenza è stata acquisita ✨\n\n💖 La fede incrollabile richiede esperienza di vita, misericordia e il vero amore di Gesù 💖\n\n🔥 Le diverse prove della vita metteranno alla prova il tuo cammino, il vero sentiero che scegliamo, il nostro cuore 🔥\n\n😔 Rimaniamo imperfetti, i nostri desideri sono numerosi, e l'amore per il guadagno o per il nostro comfort personale diventa troppo spesso la nostra priorità egoistica 😔\n\n🙏 Chiedi a Dio saggezza, il suo amore, la sua forza, e riconosci umilmente le tue debolezze, perché non possiamo nascondergli nulla... Nulla 🙏\n\n🥖 Digiuna come Daniele: privati per un momento di ciò che ami di più, nella calma e nella saggezza 🥖\n\n💫 Questo ti permetterà di ascoltare meglio Dio, di avere una disposizione del cuore pronta a trasformazioni profonde 💫\n\n🌙 Allora, i sogni e le visioni diventeranno più chiari, come per Giuseppe 🌙\n\n⚠️ Guardati dall'orgoglio: non cedere al 'ho sempre ragione' o al 'so meglio' ⚠️\n\n🎁 Perché la rivelazione di Dio è una grazia straordinaria 🎁\n\n💝 Avere fede significa entrare in una relazione e un cammino libero del cuore 💝\n\n🦸‍♂️ Ti renderà eroi potenti, capaci dell'impossibile 🦸‍♂️\n\n✝️ In cima alla conoscenza, il cuore sincero dice: 'Ti do il mio cuore Gesù e desidero essere battezzato' ✝️\n\n🏔️ Sei arrivato in cima alla montagna, tieniti forte, persevera! 🏔️\n\n⬇️ Bisogna scendere e portare questo prezioso tesoro: la speranza della vita eterna ⬇️\n\n🏆✨ BRAVO! SIAMO FIERI DI TE ✨🏆\n🌟 CORAGGIO VALOROSO PORTATORE DI PACE 🌟\n🕊️✨ CHE DIO TI BENEDICA ✨🕊️"
      }
    }
  }
};

export default chapter8Translations;
